import Debug from 'debug';
import { getSampleValueForField } from './get-sample-value-for-field.js';
const debug = Debug(`knack.core.helpers.view.get-sample-record`);
export const getSampleRecord = (fields, fieldKeys, state, sampleOptions) => {
    const record = {};
    for (let fieldIndex = 0; fieldIndex < fieldKeys.length; fieldIndex++) {
        const key = fieldKeys[fieldIndex];
        record[key] = getSampleValueForField(fields[key], state, sampleOptions);
    }
    return record;
};
